/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';

/**
 * 
 * @export
 * @interface GetTimeEntryRequest
 */
export interface GetTimeEntryRequest {
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof GetTimeEntryRequest
     */
    userId?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {any}
     * @memberof GetTimeEntryRequest
     */
    fromDate?: any | null;
    /**
     * 
     * @type {any}
     * @memberof GetTimeEntryRequest
     */
    toDate?: any | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetTimeEntryRequest
     */
    approved?: boolean | null;
}

/**
 * Check if a given object implements the GetTimeEntryRequest interface.
 */
export function instanceOfGetTimeEntryRequest(value: object): value is GetTimeEntryRequest {
    return true;
}

export function GetTimeEntryRequestFromJSON(json: any): GetTimeEntryRequest {
    return GetTimeEntryRequestFromJSONTyped(json, false);
}

export function GetTimeEntryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTimeEntryRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['userId']),
        'fromDate': json['fromDate'] == null ? undefined : json['fromDate'],
        'toDate': json['toDate'] == null ? undefined : json['toDate'],
        'approved': json['approved'] == null ? undefined : json['approved'],
    };
}

export function GetTimeEntryRequestToJSON(json: any): GetTimeEntryRequest {
    return GetTimeEntryRequestToJSONTyped(json, false);
}

export function GetTimeEntryRequestToJSONTyped(value?: GetTimeEntryRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': ActorActivityRecordActorUserIdToJSON(value['userId']),
        'fromDate': value['fromDate'],
        'toDate': value['toDate'],
        'approved': value['approved'],
    };
}

